import { CSSProperties } from 'react';

import { AppColors } from './../../theme';

type TimelineStyles = {
  timeline: CSSProperties;
  timeline__item: CSSProperties;
  timeline__itemContent: CSSProperties;
  timeline__itemLeft: CSSProperties;
  timeline__itemTitle: CSSProperties;
  timeline__itemUnits: CSSProperties;
  timeline__itemLink: CSSProperties;
  timeline__itemDisabled: CSSProperties;
  timeline__icon: CSSProperties;
};

const styles: TimelineStyles = {
  timeline: {
    padding: '16px 0px 16px 0px',
    margin: 0,
    backgroundColor: 'transparent'
  },
  timeline__item: {
    padding: '0'
  },
  timeline__itemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1
  },
  timeline__itemLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  timeline__itemTitle: {
    color: AppColors.VA.NEUTRALS._90_
  },
  timeline__itemUnits: {
    color: AppColors.VA.NEUTRALS._90_,
    marginLeft: '10px'
  },
  timeline__itemLink: {
    color: AppColors.VA.PRIMARY._50_,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: 'auto',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer'
  },
  timeline__itemDisabled: {
    color: AppColors.VA.NEUTRALS._40_
  },
  timeline__icon: {
    fontSize: '12px'
  }
};

export default styles;
